<!-- Navigation -->
<fuse-vertical-navigation
    class="dark bg-primary/60 print:hidden"
    [mode]="isScreenSmall ? 'over' : 'side'"
    [name]="'mainNavigation'"
    [navigation]="data?.navigation?.default || []"
    [autoCollapse]="false"
    [opened]="navigationOpened"
    (openedChanged)="onNavigationOpenedChanged($event)">
    <!-- Navigation header hook -->
    <ng-container fuseVerticalNavigationContentHeader>
        <div class="layout-sidebar-top-actions">
            <user-menu [showAvatar]="false"></user-menu>
            <notifications *ngIf="showHeaderUtilities" [notifications]="data?.notifications"></notifications>
        </div>
        <!-- User -->
        <div class="flex flex-col items-center w-full px-4 pt-4 pb-4" *ngIf="user">
            <div class="relative w-20 h-20">
                <img
                    class="w-full h-full rounded-full object-cover"
                    *ngIf="user.avatar"
                    [src]="user.avatar"
                    alt="User avatar">
                <mat-icon
                    class="w-20 h-20"
                    *ngIf="!user.avatar"
                    [svgIcon]="'heroicons_solid:user-circle'"></mat-icon>
            </div>
            <div class="flex flex-col items-center justify-center w-full mt-3">
                <div class="w-full whitespace-nowrap overflow-ellipsis overflow-hidden text-center leading-normal font-medium">
                    {{ userDisplayName }}
                </div>
                <div
                    *ngIf="showUserEmail"
                    class="w-full mt-0.5 whitespace-nowrap overflow-ellipsis overflow-hidden text-center text-md leading-normal font-medium">
                    {{ user.email }}
                </div>
            </div>
        </div>
    </ng-container>
    <ng-container fuseVerticalNavigationContentFooter>
        <div
            *ngIf="watermarkPath"
            class="cc-nav-watermark pointer-events-none absolute inset-0 overflow-hidden"
            [style.background-image]="'url(' + watermarkPath + ')'"
            aria-hidden="true">
        </div>
    </ng-container>
    <ng-container fuseVerticalNavigationFooter>
        <div
            *ngIf="showBuildNo"
            class="layout-sidebar-build-no w-full px-4 py-3 border-t border-white/10 text-center text-xs leading-normal font-normal opacity-60 whitespace-nowrap overflow-ellipsis overflow-hidden"
            [attr.title]="'Build ' + buildNo">
            Build {{ buildNo }}
        </div>
    </ng-container>
</fuse-vertical-navigation>

<!-- Wrapper -->
<div class="flex flex-col flex-auto w-full min-w-0">

    <!-- Header -->
    <div class="layout-header relative flex flex-col flex-0 w-full z-49 shadow dark:shadow-none dark:border-b bg-card dark:bg-transparent print:hidden">
        <div class="layout-header-bar layout-header-bar--primary flex flex-0 items-center w-full h-16 px-4 md:px-6">
            <button
                mat-icon-button
                class="layout-header-menu-toggle shrink-0"
                type="button"
                (click)="toggleNavigation('mainNavigation')"
                matTooltip="Menu"
                aria-label="Toggle navigation">
                <mat-icon [svgIcon]="'heroicons_outline:menu'"></mat-icon>
            </button>
            <div
                *ngIf="headerModuleTitle && !navigationOpened"
                class="layout-header-module-title ml-2 min-w-0 flex-1 text-lg font-semibold tracking-tight truncate">
                {{ headerModuleTitle }}
            </div>
            <div *ngIf="!(headerModuleTitle && !navigationOpened)" class="min-w-0 flex-1"></div>
            <div class="flex flex-nowrap items-center shrink-0 space-x-1 layout-header-tools">
                <header-context-menu-item
                    *ngFor="let item of headerContextMenuItems; trackBy: trackContextMenuItem"
                    [item]="item">
                </header-context-menu-item>
                <ng-container *ngFor="let action of headerToolbarActions; trackBy: trackToolbarAction">
                    <button
                        mat-icon-button
                        type="button"
                        [color]="action.color"
                        [disabled]="action.disabled"
                        [matTooltip]="action.tooltip"
                        matTooltipPosition="below"
                        [attr.aria-label]="action.ariaLabel || action.tooltip"
                        (click)="runToolbarAction(action)">
                        <mat-icon>{{ action.icon }}</mat-icon>
                    </button>
                </ng-container>
                <fuse-fullscreen></fuse-fullscreen>
            </div>
        </div>
    </div>

    <!-- Content -->
    <div class="flex flex-col flex-auto min-h-0 relative overflow-hidden">
        <ashcorp-background></ashcorp-background>
        <router-outlet *ngIf="true"></router-outlet>
    </div>

</div>
